


// ESTE ARCHIVO ES PARA GENERAR LAS FUNCIONES GLOBALES


// FUNCTION PARA RENDERIZARLA LA FECHA EN INGLES Y ESPANOL
export const renderDate = (date, language) => {

  if (!date) {
    return "";
  }


  return new Date(date).toLocaleDateString(language, { timeZone: "UTC", weekday: "short", year: "numeric", month: "short", day: "numeric", hour: "2-digit", minute: "2-digit", hour12: true });

};



// FUNCTION PARA RENDERIZAR LAS ETAPAS DE FORMA PERSONALIZADA
export const renderSteps = (idEtapa, language) => {
  let label = "";

  switch (idEtapa) {
    case 1:
      label = language === "es" ? "Recepción de su caso." : "Receipt of your case.";
      break;
    case 2:
      label = language === "es" ? "Asignación del ingeniero que atenderá la falla." : "Assignment of the field engineer to attend the failure.";
      break;
    case 3:
      label = language === "es" ? "Ya se está programando la visita del ingeniero que atenderá la falla." : "The field engineer who will attend the failure is already scheduled.";
      break;
    case 4:
      label = language === "es" ? "Estamos en espera de que usted confirme nuestra visita, para más información contacte con nuestro Call Center." : "We are waiting for you to confirm our visit, for more information please contact our Call Center";
      break;
    case 5:
      label = language === "es" ? "Hay un mantenimiento preventivo que está pendiente." : "There is a preventive maintenance that is pending";
      break;
    default:
      label = "Error";
  }

  return label;
};